import { FlowNode } from '../flowState';
import { ServicesMap } from 'app/service/types';
import getNodeAction from './getNodeAction';

const hasHookURL = (node: FlowNode, services: ServicesMap) => {
  const action = getNodeAction(node, services);
  if (!action) {
    return false;
  }
  return Boolean(action.hook_url || action.hook_legacy_url); // node.hasHookURL
};

export default hasHookURL;
